import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link } from "react-router-dom";
import TimeSince from "../Helpers/TimeSince";
import TypeIcon from "../Helpers/TypeIcon";
import ProfilePicture from "../../components/Auth/ProfilePicture";
import LazyLoad from "react-lazy-load";
import moment from "moment/moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import { faBedBunk, faCheckCircle, faPeople, faFileLines, faHouse } from "@fortawesome/pro-solid-svg-icons";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function BookingList({
    setMessageLoading,
    bookings,
    setSortFilter,
    filterLocation,
    filterGender,
    filterFunding,
    setMsgCount,
    tag_id,
    chat_tag_id,
    setShowNewMessages,
    chatsLoading,
    collection_tag_id,
    filterVendor,
    filterStatus,
    setFilterCount,
    filterStudyYear,
    filterUnitType,
    filterBookingSummary,
    filterBudget,
    filterBotFlow,
    filterDocuments,
    filterAppointment,
    filterBalance,
    filterRenewalChoice,
    filterTenantType,
    setFilterTenantType,
    property_id,
}) {
    const dispatch = useDispatch();
    const [tab, setTab] = useState(() => {
        const saved = localStorage.getItem('bookingTabGlobal');
        return saved || "open";
    });
    const [tabSort, setTabSort] = useState(() => {
        const saved = localStorage.getItem('bookingSortGlobal');
        return saved || "asc";
    });

    const { type } = useParams();
    const { current_booking } = useSelector((state) => state.booking);
    const { current_staff, staff } = useSelector((state) => state.auth);

    const [bookingsFiltered, setBookingsFiltered] = useState([]);
    const [appointmentData, setAppointmentData] = useState(null);
    const [appointmentLoading, setAppointmentLoading] = useState(false);
    const appointmentAbortRef = useRef(null);

    let booking_id = "";
    let user_id = "";

    // console.log(current_booking)

    if (current_booking) {
        booking_id = String(current_booking.id);
        user_id = current_booking.user?.id || "";
    }

    // Persist tab preference globally
    useEffect(() => {
        localStorage.setItem('bookingTabGlobal', tab);
    }, [tab]);

    // Fetch appointment data only when appointment filter is active
    useEffect(() => {
        if (!filterAppointment || filterAppointment.id === 0 || filterAppointment.id === "") {
            setAppointmentData(null);
            setAppointmentLoading(false);
            return;
        }

        if (appointmentAbortRef.current) {
            appointmentAbortRef.current.abort();
        }
        const controller = new AbortController();
        appointmentAbortRef.current = controller;

        setAppointmentLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}appointment_booking_ids`, {
            signal: controller.signal,
        })
            .then((response) => {
                setAppointmentData(response.data);
                setAppointmentLoading(false);
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                    console.error("Failed to fetch appointment data", error);
                    setAppointmentLoading(false);
                }
            });

        return () => controller.abort();
    }, [filterAppointment]);

    useEffect(() => {
        let thisTab = 0;

        if (tab === "closed") {
            thisTab = 1;
        }

        let filter1 = {};

        if (tabSort === "asc") {
            filter1 = bookings.sort((a, b) => {
                const aTime = Math.max(new Date(a.n).getTime() || 0, new Date(a.nn).getTime() || 0);
                const bTime = Math.max(new Date(b.n).getTime() || 0, new Date(b.nn).getTime() || 0);
                return bTime - aTime; // Newest first
            });
        } else {
            filter1 = bookings.sort((a, b) => {
                const aTime = Math.max(new Date(a.n).getTime() || 0, new Date(a.nn).getTime() || 0);
                const bTime = Math.max(new Date(b.n).getTime() || 0, new Date(b.nn).getTime() || 0);
                return aTime - bTime; // Oldest first
            });
        }

        let filter2 = filter1.filter((row) => {
            if (type !== "collections" && type !== "renewals") {
                return parseInt(row.g) === parseInt(thisTab);
            } else if (type === "collections") {
                return parseInt(row.w) === parseInt(thisTab);
            } else {
                return parseInt(row.ae) === parseInt(thisTab);
            }
        });

        let filter3 = filter2.filter((row) => {
            if (filterLocation && filterLocation.id != 0) {
                if (filterLocation.id === 1000) {
                    return row.i === null;
                } else {
                    return parseInt(row.i) === parseInt(filterLocation.id);
                }
            } else {
                return true;
            }
        });

        let filter4 = filter3.filter((row) => {
            if (filterGender && filterGender.id != 0) {
                return parseInt(row.x) === parseInt(filterGender.id);
            } else {
                return true;
            }
        });

        let filter5 = filter4.filter((row) => {
            if (filterFunding && filterFunding.id != 0) {
                return parseInt(row.v) === parseInt(filterFunding.id);
            } else {
                return true;
            }
        });

        let filter6 = filter5.filter((row) => {
            if (tab === "snoozed") {
                return moment(row.j).isSameOrAfter(moment(moment().format("Y-MM-DD HH:mm:ss")));
            } else {
                if (row.j === null) {
                    return true;
                } else {
                    return moment(row.j).isSameOrBefore(moment(moment().format("Y-MM-DD HH:mm:ss")));
                }
            }
        });

        if (type === "collections") {
            let filter7 = filter6.filter((row) => {
                if (filterVendor && filterVendor.id != 0) {
                    return parseInt(row.aa) === parseInt(filterVendor.id);
                } else {
                    return true;
                }
            });

            var filter8 = filter7.filter((row) => {
                if (filterStatus && filterStatus.id != 0) {
                    return parseInt(row.ab) === parseInt(filterStatus.id);
                } else {
                    return true;
                }
            });
        } else {
            var filter8 = filter6;
        }

        if (current_staff.building_manager) {
            filter8 = filter6.filter((row) => {
                var prop_id = row.i;
                if (row.i == 6 || row.i == 7 || row.i == 3) {
                    var prop_id = 6;
                }
                return parseInt(prop_id) === parseInt(current_staff.bm_property_id);
            });
        }

        // New sorting logic for robot colors (red, yellow, green)
        let filter9 = filter8.sort((a, b) => {
            // Helper function to get robot priority (red = 3, yellow = 2, green = 1)
            const getRobotPriority = (booking) => {
                if (booking.al > 0) return 2; // Yellow
                if (booking.s === "a") return 1; // Green
                return 3; // Red
            };

            const priorityA = getRobotPriority(a);
            const priorityB = getRobotPriority(b); // First sort by robot priority

            if (priorityA !== priorityB) {
                return priorityB - priorityA; // Higher priority (red) comes first
            } // If same priority, sort by timestamp

            return a.s > b.s ? -1 : 1;
        });

        let filter10 = filter9.filter((row) => {
            if (filterStudyYear && filterStudyYear.id != 0) {
                return parseInt(row.am) === parseInt(filterStudyYear.id);
            } else {
                return true;
            }
        });

        let filter11 = filter10.filter((row) => {
            if (filterUnitType && filterUnitType.id == 1) {
                return parseInt(row.ao) > 0;
            } else if (filterUnitType && filterUnitType.id == 2) {
                return parseInt(row.ao) === 0 || row.ao === null;
            } else {
                return true;
            }
        });

        let filter12 = filter11.filter((row) => {
            if (filterBookingSummary && filterBookingSummary.id == 1) {
                return row.ap === "yes";
            } else if (filterBookingSummary && filterBookingSummary.id == 2) {
                return row.ap === "no";
            } else {
                return true;
            }
        });

        let filter13 = filter12.filter((row) => {
            if (filterBudget && filterBudget.id != 0) {
                return parseInt(row.aq) === parseInt(filterBudget.id);
            } else {
                return true;
            }
        });

        let filter14 = filter13.filter((row) => {
            if (filterBotFlow && filterBotFlow.id !== 0) {
                switch (filterBotFlow.id) {
                    case 1: // Red
                        return row.s === "c";
                    case 2: // Green
                        return row.s === "a";
                    case 3: // Bot Flow
                        return row.al > 0;
                    default:
                        return true;
                }
            } else {
                return true;
            }
        });

        let filter15 = filter14.filter((row) => {
            if (filterDocuments && filterDocuments.id !== 0) {
                const docStatus = row.documents_status;
                switch (filterDocuments.id) {
                    case "missing":
                        return docStatus === "missing_required";
                    case "uploaded":
                        return docStatus === "all_uploaded" || docStatus === "not_yet_required";
                    default:
                        return true;
                }
            } else {
                return true;
            }
        });

        let filter16 = filter15.filter((row) => {
            if (filterAppointment && filterAppointment.id !== 0 && filterAppointment.id !== "" && appointmentData !== null) {
                const appts = appointmentData[row.a];
                const hasAppt = Array.isArray(appts) && appts.length > 0;

                if (filterAppointment.id === "none") return !hasAppt;
                if (filterAppointment.id === "any") return hasAppt;
                if (!hasAppt) return false;

                const today = moment().startOf('day');

                return appts.some((appt) => apptMatchesFilter(appt, filterAppointment.id));
            } else {
                return true;
            }
        });

        let filter17 = filter16.filter((row) => {
            if (filterBalance && filterBalance.id !== 0 && filterBalance.id !== "") {
                if (row.av === null || row.av === undefined || row.av === "") {
                    return false;
                }
                const balance = parseFloat(row.av);
                if (isNaN(balance)) return false;
                if (filterBalance.id === "ok") {
                    return balance <= 0;
                }
                if (filterBalance.id === "outstanding") {
                    if (balance <= 0) return false;
                    const min = filterBalance.min !== "" && filterBalance.min !== undefined ? parseFloat(filterBalance.min) : null;
                    const max = filterBalance.max !== "" && filterBalance.max !== undefined ? parseFloat(filterBalance.max) : null;
                    if (min !== null && balance < min) return false;
                    if (max !== null && balance > max) return false;
                    return true;
                }
                return true;
            } else {
                return true;
            }
        });

        let filter18 = filter17.filter((row) => {
            if (filterRenewalChoice && filterRenewalChoice.id !== 0 && filterRenewalChoice.id !== "") {
                if (!row.bb) {
                    return false;
                }
                return row.bb === filterRenewalChoice.id;
            } else {
                return true;
            }
        });

        let filter19 = filter18.filter((row) => {
            if (filterTenantType && filterTenantType.id !== 0 && filterTenantType.id !== "") {
                // TENANTS means all tenant types EXCEPT Lease Holders (and not null)
                if (filterTenantType.id === "TENANTS") {
                    return row.ay && row.ay !== "LH";
                }
                // NON_TENANTS means only bookings with no tenant type (null/empty)
                if (filterTenantType.id === "NON_TENANTS") {
                    return !row.ay || row.ay === "";
                }
                // Specific tenant type (e.g., LH)
                return row.ay === filterTenantType.id;
            } else {
                return true;
            }
        });

        setFilterCount(filter19.length);
        setBookingsFiltered(filter19);
    }, [tab, bookings, tabSort, filterLocation, filterGender, filterFunding, filterVendor, filterStatus, filterStudyYear, filterUnitType, filterBookingSummary, filterBudget, filterBotFlow, filterDocuments, filterAppointment, appointmentData, filterBalance, filterRenewalChoice, filterTenantType]);

    function apptMatchesFilter(appt, filterId) {
        if (!filterId || filterId === "any") return true;
        const apptDate = moment(appt.date);
        const today = moment().startOf('day');
        switch (filterId) {
            case "today": return apptDate.isSame(today, 'day');
            case "this_week": return apptDate.isSame(today, 'isoWeek');
            case "next_week": return apptDate.isSame(moment().add(1, 'week'), 'isoWeek');
            case "this_month": return apptDate.isSame(today, 'month');
            case "overdue": return apptDate.isBefore(today, 'day');
            default: return true;
        }
    }

    function toggleSortOrder(toggle) {
        setSortFilter(toggle);
        setTabSort(toggle);
    }

    // console.log(bookingsFiltered);

    return (
        <div className="h-auto max-h-80 xl:max-h-screen overflow-y-scroll xl:overflow-auto xl:-bottom-14 z-10 pt-14 -mt-14 xl:mt-0">
            <div>
                <span className="relative z-0 inline-flex justify-center shadow-sm w-full px-2">
                    {/* <div>
                        <button
                            type="button"
                            onClick={() => toggleAssigned("mine")}
                            className={classNames(
                                tabMe === "mine" ? "bg-white" : "",
                                "px-2 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                            )}
                        >
                            Mine
                        </button>
                        <button
                            type="button"
                            onClick={() => toggleAssigned("all")}
                            className={classNames(
                                tabMe === "all" ? "bg-white" : "",
                                "rounded-md px-2 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                            )}
                        >
                            All
                        </button>
                    </div> */}

                    <div>
                        <button
                            type="button"
                            onClick={() => toggleSortOrder("asc")}
                            className={classNames(
                                tabSort === "asc" ? "bg-white" : "",
                                "px-2 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                            )}
                        >
                            Newest
                        </button>
                        <button
                            type="button"
                            onClick={() => toggleSortOrder("desc")}
                            className={classNames(
                                tabSort === "desc" ? "bg-white" : "",
                                "rounded-md px-2 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                            )}
                        >
                            Oldest
                        </button>
                    </div>
                </span>
            </div>

            <div>
                <span className="relative z-0 inline-flex justify-center shadow-sm w-full px-2">
                    <button
                        type="button"
                        onClick={() => setTab("open")}
                        className={classNames(
                            tab === "open" ? "bg-white" : "",
                            "px-2 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                        )}
                    >
                        Open
                    </button>
                    <button
                        type="button"
                        onClick={() => setTab("snoozed")}
                        className={classNames(
                            tab === "snoozed" ? "bg-white" : "",
                            "rounded-md px-2 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                        )}
                    >
                        Snoozed
                    </button>
                    <button
                        type="closed"
                        onClick={() => setTab("closed")}
                        className={classNames(
                            tab === "closed" ? "bg-white" : "",
                            "px-2 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                        )}
                    >
                        Closed
                    </button>
                </span>
            </div>

            {process.env.REACT_APP_COLOUR !== "UC" && (
            <div>
                <span className="relative z-0 inline-flex justify-center shadow-sm w-full px-2 mt-2">
                    <button
                        type="button"
                        onClick={() => setFilterTenantType({ id: "LH", name: "Lease Holders" })}
                        className={classNames(
                            filterTenantType?.id === "LH" ? "bg-white" : "",
                            "px-2 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                        )}
                    >
                        LH
                    </button>
                    <button
                        type="button"
                        onClick={() => setFilterTenantType({ id: "TENANTS", name: "Tenants" })}
                        className={classNames(
                            filterTenantType?.id === "TENANTS" ? "bg-white" : "",
                            "rounded-md px-2 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                        )}
                    >
                        TN
                    </button>
                    <button
                        type="button"
                        onClick={() => setFilterTenantType({ id: "NON_TENANTS", name: "Non Tenants" })}
                        className={classNames(
                            filterTenantType?.id === "NON_TENANTS" ? "bg-white" : "",
                            "px-2 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition ease-linear delay-50"
                        )}
                    >
                        Unsure
                    </button>
                </span>
            </div>
            )}

            {chatsLoading && chatsLoading === true ? (
                <div className="w-full h-full text-center mt-5">
                    <span className="text-blue-comparemed top-1/2 my-0 mx-auto block relative w-72 h-72">
                        <FontAwesomeIcon icon={faSpinnerThird} className="text-black animate-spin text-5xl" />
                    </span>
                </div>
            ) : (
                <div>
                    {bookingsFiltered.length ? (
                        bookingsFiltered.map((booking) => (
                            <LazyLoad height={118} key={"booking_" + booking.a} threshold={0.55}>
                                <div key={booking.a}>
                                    <Link
                                        to={(() => {
                                            // For chat tags, preserve the tag ID in the path
                                            let url = chat_tag_id 
                                                ? "/booking/" + type + "/" + chat_tag_id + "?user_id=" + booking.f + "&booking_id=" + booking.a
                                                : "/booking/" + type + "?user_id=" + booking.f + "&booking_id=" + booking.a;
                                            if (property_id) url += "&property_id=" + property_id;
                                            if (tag_id > 0 || tag_id === "orphaned") url += "&tag=" + tag_id;
                                            else if (collection_tag_id > 0 || collection_tag_id === "-1") url += "&collection_tag=" + (collection_tag_id > 0 ? collection_tag_id : -1);
                                            return url;
                                        })()}
                                    >
                                        <div
                                            className={classNames(
                                                booking.f === user_id ? "border-l-primary bg-gray-100" : "bg-light_background border-l-light_background",
                                                "border-l-8 p-4 hover:cursor-pointer hover:bg-gray-200 hover:border-l-primary_hover transition ease-linear delay-10"
                                            )}
                                            // onClick={() => {
                                            //     setShowNewMessages(true);
                                            //     //     // if current applicant is selected, remove the onclick event
                                            //     //     if (current_booking !== booking.a) {
                                            //     console.log("getBooking 2");
                                            //     dispatch(getBooking(booking.a));
                                            //     //         setMessageLoading(true);
                                            //     //         setMsgCount(25);
                                            //     //     }
                                            // }}
                                        >
                                            {/* {console.log(booking)} */}
                                            <div className="flex space-x-3 items-center relative">
                                                <div>
                                                    <span className="inline-block relative">
                                                        <TypeIcon
                                                            platform={
                                                                booking.m && booking.mm
                                                                    ? new Date(booking.m).getTime() > new Date(booking.mm).getTime()
                                                                        ? booking.m
                                                                        : booking.mm
                                                                    : booking.m || booking.mm
                                                            }
                                                            className="h-8 w-8 text-gray-400"
                                                        />
                                                        <span
                                                            className={classNames(
                                                                booking.al > 0
                                                                    ? "bg-yellow-400"
                                                                    : booking.s === "a"
                                                                    ? "bg-green-400"
                                                                    : "bg-red-400",
                                                                "absolute top-0 right-0 block h-2 w-2 rounded-full ring-1 ring-white"
                                                            )}
                                                        />
                                                    </span>
                                                    {(booking.ay || (process.env.REACT_APP_COLOUR === "UC" && (booking.ba === true || booking.ba === 1))) && (
                                                        <div className="text-xs text-white capitalize absolute left-0 -top-2 bg-primary rounded-full px-2 py-0.5">
                                                            {booking.ay && process.env.REACT_APP_COLOUR === "UC" && (booking.ba === true || booking.ba === 1) ? `${booking.ay}/R` : process.env.REACT_APP_COLOUR === "UC" && (booking.ba === true || booking.ba === 1) ? 'R' : booking.ay}
                                                        </div>
                                                    )}
                                                    <div className="absolute bottom-0 left-0">{booking.an > 0 && <FontAwesomeIcon icon={faPeople} className="h-5 w-5 text-primary" />}</div>
                                                    {process.env.REACT_APP_COLOUR === "UC" && (
                                                        <div className="absolute bottom-0 left-6">
                                                            {booking.documents_status && (
                                                                <FontAwesomeIcon 
                                                                    icon={faFileLines} 
                                                                    className={`h-4 w-4 ${
                                                                        booking.documents_status === "missing_required" 
                                                                            ? "text-red-500" 
                                                                            : "text-green-500"
                                                                    }`}
                                                                    title={
                                                                        booking.documents_status === "missing_required" 
                                                                            ? "Missing required documents" 
                                                                            : "All documents uploaded"
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                    )}
                                                    <div className="absolute top-0 right-0">{booking.ap === "yes" && <FontAwesomeIcon icon={faCheckCircle} className="h-5 w-5 text-primary" />}</div>
                                                    <div className="absolute top-0 right-6">
                                                        {process.env.REACT_APP_COLOUR === "UC" && booking.ar > 0 && (
                                                            <FontAwesomeIcon
                                                                icon={faBedBunk}
                                                                className={`h-5 w-5 ${booking.au !== null ? "text-pink-500" : booking.at !== null ? "text-black" : "text-blue-500"}`}
                                                            />
                                                        )}
                                                        {process.env.REACT_APP_COLOUR === "QL" && booking.ar2 > 0 && (
                                                            <FontAwesomeIcon
                                                                icon={faHouse}
                                                                className={`h-5 w-5 ${
                                                                    (() => {
                                                                        if (booking.au !== null) {
                                                                            return "text-pink-500";  // Move In Inspection done - pink (highest priority)
                                                                        } else if (booking.at !== null && booking.axx == 1) {
                                                                            return "text-purple-500";  // Partially Paid - purple (2nd priority)
                                                                        } else if (booking.at !== null && booking.ax == 1) {
                                                                            return "text-blue-500";  // Fully Paid & Signed - blue (3rd priority)
                                                                        } else if (booking.at !== null) {
                                                                            return "text-black";  // Lease signed - black (4th priority)
                                                                        } else {
                                                                            return "text-gray-400";  // Default fallback
                                                                        }
                                                                    })()
                                                                }`}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="flex-1 space-y-2">
                                                    <p
                                                        className={classNames(
                                                            booking.az === 2
                                                                ? "text-red-500"
                                                                : booking.az === 1
                                                                ? "text-purple-500"
                                                                : "",
                                                            " font-light truncate w-48 capitalize"
                                                        )}
                                                    >
                                                        {booking.e}
                                                        {(type === "all" || type === "you" || type === "mentions") && " - " + booking.p}
                                                    </p>
                                                    <div className="flex items-center justify-between flex-wrap">
                                                        <h3
                                                            className={classNames(
                                                                booking.az === 2
                                                                    ? "text-red-600"
                                                                    : booking.az === 1
                                                                    ? "text-purple-600"
                                                                    : "text-gray-600",
                                                                " xl:w-28 xl:truncate w-2/3 overflow-auto"
                                                            )}
                                                        >
                                                            {booking.b} {booking.c ? booking.c : ""}
                                                        </h3>
                                                        <p
                                                            className={classNames(
                                                                booking.az === 2
                                                                    ? "text-red-500"
                                                                    : booking.az === 1
                                                                    ? "text-purple-500"
                                                                    : "text-gray-500",
                                                                " text-sm"
                                                            )}
                                                        >
                                                            {booking.n || booking.nn ? <TimeSince time={Math.max(new Date(booking.n || 0).getTime(), new Date(booking.nn || 0).getTime())} /> : null}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p
                                                            className={classNames(
                                                                booking.az === 2
                                                                    ? "text-red-500"
                                                                    : booking.az === 1
                                                                    ? "text-purple-500"
                                                                    : "text-gray-500",
                                                                " text-sm truncate w-48"
                                                            )}
                                                        >
                                                            {(() => {
                                                                if (appointmentData && Array.isArray(appointmentData[booking.a]) && appointmentData[booking.a].length > 0) {
                                                                    const filteredAppts = filterAppointment && filterAppointment.id && filterAppointment.id !== 0 && filterAppointment.id !== "any" && filterAppointment.id !== "none"
                                                                        ? appointmentData[booking.a].filter(appt => apptMatchesFilter(appt, filterAppointment.id))
                                                                        : appointmentData[booking.a];
                                                                    if (filteredAppts.length > 0) {
                                                                        return filteredAppts.map((appt, idx) => (
                                                                            <span key={idx} title={`${appt.name || 'Appointment'}: ${moment(appt.date).format('ddd D MMM YYYY')}${appt.time ? ' ' + appt.time : ''}`}>
                                                                                {idx > 0 && ", "}
                                                                                <span className={
                                                                                    moment(appt.date).isBefore(moment().startOf('day')) ? "text-red-500 font-medium" :
                                                                                    moment(appt.date).isSame(moment(), 'day') ? "text-green-600 font-medium" :
                                                                                    "text-blue-500 font-medium"
                                                                                }>
                                                                                    {appt.name ? appt.name.split(' ').map(w => w[0]).join('') : ''} {moment(appt.date).format('D/M')}
                                                                                </span>
                                                                            </span>
                                                                        ));
                                                                    }
                                                                }
                                                                const nTime = new Date(booking.n).getTime() || 0;
                                                                const nnTime = new Date(booking.nn).getTime() || 0;

                                                                if (nnTime > nTime) {
                                                                    return booking.oo ? booking.oo.replace(/<\/?[^>]+(>|$)/g, "") : booking.o ? booking.o.replace(/<\/?[^>]+(>|$)/g, "") : "No Message";
                                                                } else {
                                                                    return booking.o ? booking.o.replace(/<\/?[^>]+(>|$)/g, "") : booking.oo ? booking.oo.replace(/<\/?[^>]+(>|$)/g, "") : "No Message";
                                                                }
                                                            })()}
                                                        </p>
                                                    </div>
                                                    {filterBalance && filterBalance.id !== 0 && filterBalance.id !== "" && booking.av != null && (
                                                        <span className={`inline-block text-xs font-medium px-1.5 py-0.5 rounded-full ${parseFloat(booking.av) <= 0 ? "bg-green-100 text-green-700" : parseFloat(booking.av) > 2000 ? "bg-red-100 text-red-700" : "bg-yellow-100 text-yellow-700"}`}>
                                                            R{parseFloat(booking.av).toFixed(2)}
                                                        </span>
                                                    )}
                                                </div>

                                                <div className="absolute top-0 right-0 flex items-center space-x-2">
                                                    {booking?.exu && moment(booking.exu).isAfter(moment()) && (
                                                        <span
                                                            title={`Experiment block until ${moment(booking.exu).format('YYYY-MM-DD HH:mm')}`}
                                                            className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 whitespace-nowrap shadow"
                                                        >
                                                            48h Block
                                                        </span>
                                                    )}
                                                    {booking?.assigned_to && Array.isArray(booking.assigned_to) > 0 ? booking.assigned_to.map((a) => <ProfilePicture key={a} id={a} size="20" />) : ""}
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                    <hr className="border-t-2" />
                                </div>
                            </LazyLoad>
                        ))
                    ) : (
                        <></>
                    )}
                </div>
            )}
        </div>
    );
}
